import { Table } from "antd";
import { Ticket } from "@ticketingplatform/api/dist/ticket/fragments/__generated__/Ticket";

import { TicketTableProps } from "./types";
import { useTicketColumns } from "./hooks";

const TicketTable = <TTicket extends Ticket = Ticket>({
  additionalColumns,
  ...props
}: TicketTableProps<TTicket>): React.ReactElement => {
  const columns = useTicketColumns({ additionalColumns });

  return <Table rowKey="id" {...{ columns }} {...props} />;
};

export default TicketTable;
